module.exports = __webpack_public_path__ + "static/tv-person-f4507c43636c64c3ca96dfb139b089e6.png";